export const getOfferFrequency = (
  duration: string,
  translate: (key: string) => string,
  isAdjective?: boolean,
) => {
  // Extract the numeric part and the time unit from the input string
  const number = parseInt(duration.slice(0, -1));
  const unit = duration.slice(-1);

  const weekLabel = translate(isAdjective ? "weekly" : "week");
  const monthLabel = translate(isAdjective ? "monthly" : "month");
  const quarterLabel = translate(isAdjective ? "quarterly" : "quarter");
  const yearLabel = translate(isAdjective ? "yearly" : "year_lower");

  let result = "";
  switch (unit) {
    case "w":
      result = number === 1 ? weekLabel : `${number} ${weekLabel}`;
      break;
    case "m":
      result =
        number === 1
          ? monthLabel
          : number === 3
            ? quarterLabel
            : `${number} ${monthLabel}`;
      break;
    case "y":
      result = number === 1 ? yearLabel : `${number} ${yearLabel}`;
      break;
    default:
      result = translate("Period");
  }

  return result;
};
